<!-- Header -->
<div class="modal-header bg-head-realtion py-2">
  <h6 class="modal-title">Admin : Question Management : Select Course</h6>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCross()"></button>
</div>

<!-- Body -->
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <h4>Applicable Course Type</h4>
        <div class="d-flex flex-wrap gap-3">
          <div *ngFor="let ccType of courseCategoryList; let cCI = index">
            <input
              type="radio"
              name="selectedCourseCategory"
              [value]="ccType.Code"
              [checked]="selectedCategory === ccType.Code"
              (change)="onCategoryTypeChange(ccType.Code)"
            />
            {{ ccType.Description }}
          </div>
        </div>
      </div>
      <div class="col-12 mt-3" *ngIf="selectedCategory">
        <h4>Applicable Courses</h4>
        <div class="fw-bold fs-5 mb-2">
          {{ getCategoryNameByCode(selectedCategory) }}
          <!-- <i class="fa fa-plus" (click)="addApplicableCourses(getCategoryByCode(selectedCategory))"></i> -->
        </div>
        <table class="table" *ngIf="getCoursesByCategory(selectedCategory).length > 0">
          <thead>
            <tr>
              <th style="width: 30%;">Exam Agency</th>
              <th style="width: 30%;">Course Name</th>
              <th style="width: 15%;">Course Year / Month</th>
              <!-- <th style="width: 15%; text-align: center;">Actions</th> -->
            </tr>
          </thead>
          <tbody formArrayName="applicableCourses">
            <tr *ngFor="let appExam of getCoursesByCategory(selectedCategory); let aCI = index" [formGroupName]="applicableCoursesArray.controls.indexOf(appExam)">
              <td style="width: 30%;">
                <select class="form-control" formControlName="examAgency"
                  (change)="fetchCourseBasedOnExam(appExam, getCategoryByCode(selectedCategory))">
                  <option [value]="null" hidden></option>
                  <option *ngFor="let s of appExam.value.examAgencyList" [value]="s.Code">
                    {{ s.Description }}
                  </option>
                </select>
              </td>
              <td style="width: 30%;">
                <select class="form-control" formControlName="courseId"
                  (change)="fetchCourseYear(appExam, getCategoryByCode(selectedCategory))">
                  <option [value]="null" hidden></option>
                  <option *ngFor="let s of appExam.value.courseList" [value]="s.Code">
                    {{ s.Description }}
                  </option>
                </select>
              </td>
              <td style="width: 15%;">
                <select class="form-control" formControlName="examYear"
                  (change)="onCourseYearChange(appExam, getCategoryByCode(selectedCategory))">
                  <option [value]="null" hidden></option>
                  <option *ngFor="let s of appExam.value.courseYear" [value]="s.Code">
                     {{ s.Description }}
                  </option>
                </select>
              </td>
              <!-- <td style="width: 15%; text-align: center;">
                <button type="button" class="btn btn-danger btn-sm" (click)="removeCourse(appExam)">
                  <i class="fa fa-trash"></i>
                </button>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
</div>

<!-- Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-primary bl-btn" (click)="onSave()">Select</button>
  <button type="button" class="btn btn-light btn-sm border" (click)="onCross()">Cancel</button>
</div>
